export default __webpack_public_path__ + "static/media/project-ssprintsplus.872fa1f6.png";